import svcReducer from './reducers';

export default { reducer: svcReducer };
